// extracted by mini-css-extract-plugin
module.exports = {"headSection":"GrantedPopup-module__headSection","point":"GrantedPopup-module__point"};